import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import './SuccessIcon.css';
import successIcon from '../../assets/img/success.svg';

/**
 * SuccessIcon component with a custom animation.
 * The animation zooms, scales to larger size, fades in, and spins.
 * Includes an onAnimationEnd callback and configurable scale size.
 */
const SuccessIcon = ({
  src = successIcon,
  alt,
  duration = '2s',
  delay = '0s',
  scale = 1.2,
  onAnimationEnd,
  className,
  ...props
}) => {
  const iconRef = useRef(null);

  useEffect(() => {
    const element = iconRef.current;
    if (element && onAnimationEnd) {
      const handleAnimationEnd = () => onAnimationEnd();
      element.addEventListener('animationend', handleAnimationEnd);

      return () => {
        element.removeEventListener('animationend', handleAnimationEnd);
      };
    }
  }, [onAnimationEnd]);

  const style = {
    animationDuration: duration,
    animationDelay: delay,
    '--icon-scale': scale, // Custom property to control scale in CSS
  };

  return (
    <img
      ref={iconRef}
      src={src}
      alt={alt}
      className={`success-icon ${className}`}
      style={style}
      {...props}
    />
  );
};

SuccessIcon.propTypes = {
  alt: PropTypes.string.isRequired,
  duration: PropTypes.string,
  delay: PropTypes.string,
  scale: PropTypes.number,
  onAnimationEnd: PropTypes.func,
  className: PropTypes.string,
};

SuccessIcon.defaultProps = {
  duration: '2s',
  delay: '0s',
  scale: 1.2,
  onAnimationEnd: null,
  className: '',
};

export default SuccessIcon;
